<p-confirmDialog [style]="{ width: '420px' }" />

<div class="container-fluid mt-2 pending-page">
  <div class="pending-shell">
    <div class="pending-toolbar">
      <div class="toolbar-top">
        <div class="toolbar-title">
          <h5 class="mb-0">
            Self Registrations
            <span class="count-badge" *ngIf="pendingCount > 0">{{ pendingCount }} pending</span>
          </h5>
          <small>Review patient submissions from the public registration page</small>
        </div>

        <button class="btn btn-light border refresh-btn" type="button" (click)="load()">
          <i class="pi pi-refresh me-1"></i> Refresh
        </button>
      </div>

      <div class="toolbar-controls">
        <div class="status-tabs">
          <button
            *ngFor="let opt of statusOptions"
            type="button"
            class="status-tab"
            [class.active]="statusFilter === opt.value"
            (click)="setStatus(opt.value)">
            {{ opt.label }}
          </button>
        </div>

        <div class="search-wrap">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="form-control"
            placeholder="Search name or mobile..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()" />
        </div>
      </div>
    </div>

    <div class="pending-table-card">
      <div class="table-responsive">
        <table class="table modern-table align-middle mb-0">
          <thead>
            <tr>
              <th>Patient</th>
              <th>Mobile</th>
              <th>Age</th>
              <th>City</th>
              <th>Submitted</th>
              <th>Status</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of records">
              <td>
                <div class="patient-cell">
                  <span class="patient-avatar">{{ initials(item.full_name) }}</span>
                  <div class="patient-meta">
                    <span class="patient-name">
                      <span class="salutation" *ngIf="item.salutation">{{ item.salutation }}</span>
                      {{ item.full_name }}
                    </span>
                    <small class="patient-extra" *ngIf="item.occupation">{{ item.occupation }}</small>
                    <span
                      class="family-hint"
                      *ngIf="item.status === 'pending' && item.family_matches?.length"
                      title="An existing family card was found for this mobile number">
                      <i class="pi pi-users"></i> Possible family card
                    </span>
                  </div>
                </div>
              </td>
              <td>{{ item.contact_number }}</td>
              <td>{{ displayAge(item) }}</td>
              <td>{{ item.city || '-' }}</td>
              <td>{{ item.created_at ? (item.created_at | date: 'dd MMM, h:mm a') : '-' }}</td>
              <td>
                <span class="status-chip" [ngClass]="statusClass(item.status)">
                  {{ item.status | titlecase }}
                </span>
              </td>
              <td class="text-end action-cell">
                <ng-container *ngIf="item.status === 'pending'; else reviewedInfo">
                  <button
                    class="btn btn-sm action-approve"
                    type="button"
                    [disabled]="processingId === item.id"
                    (click)="approve(item)"
                    title="Approve">
                    <i class="pi" [ngClass]="processingId === item.id ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                    Approve
                  </button>
                  <button
                    class="btn btn-sm action-reject"
                    type="button"
                    [disabled]="processingId === item.id"
                    (click)="reject(item)"
                    title="Reject">
                    <i class="pi pi-times"></i>
                  </button>
                </ng-container>
                <ng-template #reviewedInfo>
                  <span class="reviewed-note">
                    <i class="pi pi-clock"></i>
                    {{ item.reviewed_at ? (item.reviewed_at | date: 'dd MMM') : '' }}
                  </span>
                </ng-template>
              </td>
            </tr>

            <tr *ngIf="!loading && records.length === 0">
              <td colspan="7" class="empty-state text-center py-5">
                <i class="pi pi-inbox mb-2 d-block"></i>
                No {{ statusFilter === 'all' ? '' : statusFilter }} registrations found.
              </td>
            </tr>

            <ng-container *ngIf="loading">
              <tr *ngFor="let i of [1, 2, 3, 4, 5]">
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
                <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="table-pagination" *ngIf="totalRecords > 0">
        <div class="pagination-info d-flex align-items-center gap-3">
          <div>
            Showing
            {{ (currentPage - 1) * pageSize + 1 }}
            -
            {{ (currentPage - 1) * pageSize + records.length }}
            of {{ totalRecords }}
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted" style="font-size: 0.85rem;">Per page:</span>
            <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="pageSize" (change)="onPageSizeChanged()">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="15">15</option>
              <option [value]="30">30</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>
          </div>
        </div>

        <div class="pagination-controls">
          <button
            class="page-btn"
            type="button"
            [disabled]="currentPage === 1"
            (click)="goToPreviousPage()"
          >
            <i class="pi pi-angle-left"></i>
          </button>
          <button
            class="page-btn"
            type="button"
            *ngFor="let page of visiblePageNumbers"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
          <button
            class="page-btn"
            type="button"
            [disabled]="currentPage === totalPages"
            (click)="goToNextPage()"
          >
            <i class="pi pi-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Approve registration"
  [(visible)]="showApproveDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '520px' }"
  styleClass="approve-dialog">
  <ng-container *ngIf="approvingRecord as rec">
    <div class="approve-subject">
      <span class="patient-avatar">{{ initials(rec.full_name) }}</span>
      <div>
        <div class="approve-name">
          <span class="salutation" *ngIf="rec.salutation">{{ rec.salutation }}</span>
          {{ rec.full_name }}
        </div>
        <small class="text-muted">{{ rec.contact_number }} · Age {{ displayAge(rec) }}</small>
      </div>
    </div>

    <p class="approve-question">Which family card should this patient be added to?</p>

    <div class="card-choices">
      <button
        type="button"
        class="card-choice"
        [class.selected]="selectedCardId === null"
        (click)="selectCard(null)">
        <div class="choice-head">
          <i class="pi pi-id-card"></i>
          <span>Create a new family card</span>
          <i class="pi pi-check choice-tick" *ngIf="selectedCardId === null"></i>
        </div>
        <small>A brand new card number will be generated for this patient.</small>
      </button>

      <ng-container *ngIf="familyMatches.length">
        <div class="choice-divider">
          <span>Existing cards on this mobile number</span>
        </div>

        <button
          *ngFor="let card of familyMatches"
          type="button"
          class="card-choice"
          [class.selected]="selectedCardId === card.id"
          (click)="selectCard(card.id)">
          <div class="choice-head">
            <i class="pi pi-users"></i>
            <span>Card {{ card.number }}</span>
            <span class="member-count">{{ card.patient_count }} member{{ card.patient_count === 1 ? '' : 's' }}</span>
            <i class="pi pi-check choice-tick" *ngIf="selectedCardId === card.id"></i>
          </div>
          <small class="members">
            <span *ngFor="let m of card.patients; let last = last">
              {{ m.full_name }}<span *ngIf="!last">, </span>
            </span>
          </small>
        </button>
      </ng-container>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <button class="btn btn-light border" type="button" (click)="showApproveDialog = false">Cancel</button>
    <button class="btn btn-success" type="button" (click)="confirmApprove()">
      <i class="pi pi-check me-1"></i>
      {{ selectedCardId ? 'Add to family card' : 'Create patient' }}
    </button>
  </ng-template>
</p-dialog>
